var map = {
	"./131896-estatua_de_la_libertad-8576x5696.jpg": 785,
	"./162816-3840x2160-desktop-4k-turkey-wallpaper-photo.jpg": 849,
	"./pexels-marc-coenen-298185-3675435.jpg": 814,
	"./photo-1529154166925-574a0236a4f4.jpeg": 488,
	"./photo-1551126892-7cf2e2d9a4d9.jpeg": 837,
	"./wp2309539.jpg": 118,
	"./xtZ9Of.jpg": 914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 229;